// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__31wuh","title":"Images90_title__17NGD","images":"Images90_images__181Si"};